import { SmlJsonQueryFilter, SmlJsonQueryOrder } from "@src/types/intelligence-search";
import React from "react";
import { JsonQueryBuilderConfig } from "../query-builder";
import {
    TemplateSearchOrderLimit,
    TemplateSearchOrderLimitValue,
} from "@src/components/intelligence-search/template-search";
import { getMemberColor } from "@src/util/intelligence-search/get-member-info";
import { SearchQueryOrderLimitTemplateV2 } from "@src/components/intelligence-search";

export const DEFAULT_LIMIT = 10000;

export const filterOutOrderWithoutFilter = (orders: SmlJsonQueryOrder[], filters: (string | SmlJsonQueryFilter)[]) => {
    return orders.filter((order) => {
        return filters.some((filter) => {
            if (typeof filter === "string") {
                return order.name === filter;
            }
            return filter.name === order.name;
        });
    });
};
export const OrderAndLimitConfig: React.FC<{
    value?: JsonQueryBuilderConfig;
    handleChange: ({
        selectedAssetsOrFilters,
        limit,
        orders,
    }: {
        selectedAssetsOrFilters?: SmlJsonQueryFilter[];
        orders?: SmlJsonQueryOrder[];
        limit?: number;
    }) => void;
    filters: SmlJsonQueryFilter[];
}> = ({ value, handleChange, filters }) => {
    const handleOk = (value: TemplateSearchOrderLimitValue) => {
        handleChange({
            orders: value.orders,
            limit: value.limit,
        });
    };

    const { orders, limit, selected_assets_or_filters } = value ?? {
        limit: DEFAULT_LIMIT,
        orders: [],
        selected_assets_or_filters: [],
    };
    const initQueryOrder = filterOutOrderWithoutFilter(orders ?? [], selected_assets_or_filters ?? []);
    const initQueryLimit = limit;

    const options = filters
        .filter((f) => !f.operator)
        .map((f) => ({
            label: f.meta?.title ?? f.meta?.name ?? "",
            value: f.meta?.name ?? "",
            meta: f.meta,
        }));
    return (
        <>
            <SearchQueryOrderLimitTemplateV2
                initValue={{
                    orders: initQueryOrder.map((order) => {
                        const itemMeta = options.find((o) => o.value === order.name)?.meta;
                        return {
                            label: itemMeta?.title ?? itemMeta?.name ?? "",
                            value: order.name,
                            direction: order.direction,
                            meta: itemMeta,
                        };
                    }),
                    limit: initQueryLimit ?? DEFAULT_LIMIT,
                }}
                orderOptions={options}
                onApply={(value) => {
                    handleOk({
                        orders: value.orders.map((order) => ({
                            name: order.value,
                            direction: order.direction,
                        })),
                        limit: value.limit,
                    });
                }}
                validate={{
                    fields: ["limit"],
                }}
            />
        </>
    );
};
